import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchMyPermissions = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/auth/my-permissions`, {
      headers: authHeader(),
    })
    .then((res) => res.data.data);
};

export const loginUser = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/auth`, data)
      .then((response) => {
        toast.success(response.data.msg);
        return resolve(response.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) {
          toast.error(err.response.data.msg);
        } else {
          toast.error("Login failed");
        }
        return reject(err);
      });
  });
};
